"use strict";
// This module should contained ag-ui base schemas OR shared schemas,
// do not add any one-off schemas here.
// This module is shared by browser and server in-app-agent code. Keep it
// runtime-neutral: Zod schemas and TypeScript types only, with no React,
// browser-only, server-only, database, or Mastra imports.
Object.defineProperty(exports, "__esModule", { value: true });
exports.InAppAgentToolApprovalRequestSchema = exports.AgUiContextSchema = exports.AgUiMessageSchema = exports.InAppAgentRedirectActionToolResultSchema = exports.InAppAgentRateLimitErrorResponseSchema = void 0;
const zod_1 = require("zod");
// @ag-ui/core@0.0.52 publishes Zod v3-shaped declarations, but this package
// uses Zod v4, causing its exported z.infer-based types to resolve as unknown.
// Duplicate the relevant schemas locally until
// https://github.com/ag-ui-protocol/ag-ui/pull/1637 is merged, then remove
// these definitions and use @ag-ui/core directly again.
const AgUiBaseMessageSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string().optional(),
    encryptedValue: zod_1.z.string().optional(),
});
const AgUiToolCallSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: zod_1.z.literal("function"),
    function: zod_1.z.object({
        name: zod_1.z.string(),
        arguments: zod_1.z.string(),
    }),
    encryptedValue: zod_1.z.string().optional(),
});
exports.InAppAgentRateLimitErrorResponseSchema = zod_1.z.object({
    code: zod_1.z.literal("rate_limited"),
    details: zod_1.z.object({
        retryAfterSeconds: zod_1.z.number().int().positive(),
    }),
});
// Changes to this schema need to be backwards-compatible as messages with this are already persisted.
exports.InAppAgentRedirectActionToolResultSchema = zod_1.z.object({
    type: zod_1.z.literal("redirectAction"),
    label: zod_1.z.string().min(1).max(80),
    href: zod_1.z.string().min(1),
});
const AgUiInputContentSourceSchema = zod_1.z.discriminatedUnion("type", [
    zod_1.z.object({
        type: zod_1.z.literal("data"),
        value: zod_1.z.string(),
        mimeType: zod_1.z.string(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal("url"),
        value: zod_1.z.string(),
        mimeType: zod_1.z.string().optional(),
    }),
]);
const AgUiInputContentSchema = zod_1.z.discriminatedUnion("type", [
    zod_1.z.object({
        type: zod_1.z.literal("text"),
        text: zod_1.z.string(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal("image"),
        source: AgUiInputContentSourceSchema,
        metadata: zod_1.z.unknown().optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal("audio"),
        source: AgUiInputContentSourceSchema,
        metadata: zod_1.z.unknown().optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal("video"),
        source: AgUiInputContentSourceSchema,
        metadata: zod_1.z.unknown().optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal("document"),
        source: AgUiInputContentSourceSchema,
        metadata: zod_1.z.unknown().optional(),
    }),
    zod_1.z.object({
        type: zod_1.z.literal("binary"),
        mimeType: zod_1.z.string(),
        id: zod_1.z.string().optional(),
        url: zod_1.z.string().optional(),
        data: zod_1.z.string().optional(),
        filename: zod_1.z.string().optional(),
    }),
]);
exports.AgUiMessageSchema = zod_1.z.discriminatedUnion("role", [
    AgUiBaseMessageSchema.extend({
        role: zod_1.z.literal("developer"),
        content: zod_1.z.string(),
    }),
    AgUiBaseMessageSchema.extend({
        role: zod_1.z.literal("system"),
        content: zod_1.z.string(),
    }),
    AgUiBaseMessageSchema.extend({
        role: zod_1.z.literal("assistant"),
        content: zod_1.z.string().optional(),
        toolCalls: zod_1.z.array(AgUiToolCallSchema).optional(),
        runId: zod_1.z.string().optional(),
    }),
    AgUiBaseMessageSchema.extend({
        role: zod_1.z.literal("user"),
        content: zod_1.z.union([zod_1.z.string(), zod_1.z.array(AgUiInputContentSchema)]),
    }),
    zod_1.z.object({
        id: zod_1.z.string(),
        content: zod_1.z.string(),
        role: zod_1.z.literal("tool"),
        toolCallId: zod_1.z.string(),
        error: zod_1.z.string().optional(),
        encryptedValue: zod_1.z.string().optional(),
    }),
    zod_1.z.object({
        id: zod_1.z.string(),
        role: zod_1.z.literal("activity"),
        activityType: zod_1.z.string(),
        content: zod_1.z.record(zod_1.z.string(), zod_1.z.any()),
    }),
    zod_1.z.object({
        id: zod_1.z.string(),
        role: zod_1.z.literal("reasoning"),
        content: zod_1.z.string(),
        encryptedValue: zod_1.z.string().optional(),
    }),
]);
exports.AgUiContextSchema = zod_1.z.object({
    description: zod_1.z.string(),
    value: zod_1.z.string(),
});
exports.InAppAgentToolApprovalRequestSchema = zod_1.z.object({
    type: zod_1.z.literal("tool_approval_request"),
    toolCallId: zod_1.z.string().min(1),
    toolName: zod_1.z.string().min(1),
    args: zod_1.z.unknown().optional(),
    runId: zod_1.z.string().min(1),
});
